import React from 'react';
import { Modal, Table, Form, Empty, Input, Button } from 'antd';
import auth from '../../../common/utility/auth';
import global from '../../../common/utility/global';
import { LOGISTICA_PRODUCTOS_CON_LOTE, VENTA_PRECIO_UNITARIO_INCLUYE_IGV } from '../../../common/types/parametroType'
import { VENTAS, LOGISTICA } from '../../../common/types/sistemaType'

const { Search } = Input;

class SearchProductModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleSearch = (value) => {
        const dataSource = this.props.dataSource.filter(item => {
            return global.formatSearch(`${item.codigoReferencia} - ${item.nombre}`).match(global.formatSearch(value));
        });
        this.props.form.setFieldsValue({ dataSource });
    };

    render() {
        const precioUnitarioInclIGV = auth.user().parametros.filter(m => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;
        const mostrarLoteProducto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
        if (this.props.dataSourceAgregado !== undefined && this.props.dataSourceAgregado.length !== 0) {
            this.props.dataSource.forEach(element => {
                var exist = this.props.dataSourceAgregado.filter(m => m.idProducto === element.id && m.numeroLote === element.numeroLote);
                if (exist.length !== 0)
                    element['flagAgregado'] = true;
            });
        }
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('dataSource', { initialValue: this.props.dataSource });
        getFieldDecorator('loading', { initialValue: false });
        return (
            <Modal
                className='table-search-product-component'
                title={"Búsqueda de Producto ó Servicio"}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="1000px"
                onCancel={() => {
                    this.props.form.resetFields();
                    this.props.onCancel()
                }}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={() => {
                            this.props.form.resetFields();
                            this.props.onCancel()
                        }}
                    >
                        Ok
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="">
                                {getFieldDecorator('codigoNombre', {
                                    initialValue: ''
                                })(
                                    <Search
                                        placeholder="Búsqueda por Código o Nombre"
                                        autoComplete="off"
                                        maxLength={100}
                                        loading={getFieldValue('loading')}
                                        onSearch={value => this.props.validarStock ? this.props.onBuscarProducto(value) : this.handleSearch(value)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                rowClassName={(record, index) => !record.flagAgregado ? 'cursor-pointer' : 'cursor-pointer agregados'}
                                className="table-search-product-component"
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => `${record.id}-${record.numeroLote}`}
                                dataSource={getFieldValue('dataSource')}
                                onRow={(item) => ({ onClick: () => (this.props.onSelect(item)) })}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Código',
                                        dataIndex: 'codigoReferencia',
                                        key: 'codigoReferencia'
                                    },
                                    {
                                        title: 'Nombre',
                                        dataIndex: 'nombre',
                                        key: 'nombre'
                                    },
                                    {
                                        title: 'Tipo de Producto',
                                        dataIndex: 'nombreTipoProducto',
                                        key: 'nombreTipoProducto'
                                    },
                                    {
                                        title: 'Unidad de Medida',
                                        dataIndex: 'nombreUnidadMedida',
                                        key: 'nombreUnidadMedida'
                                    },
                                    {
                                        title: 'Marca',
                                        dataIndex: 'nombreMarca',
                                        key: 'nombreMarca'
                                    },
                                    {
                                        title: 'Lote',
                                        dataIndex: 'numeroLote',
                                        key: 'numeroLote',
                                        className: mostrarLoteProducto ? 'show' : 'hide'
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(SearchProductModal)